import { Box } from '@fairfashion/design-system'

import { PendingItemsTab } from './components/PendingItemsTab/pending-items-tab.comp'
import { ProviderItemsProvider } from './provider-items.context'
import * as Styles from './provider-items.styles'

const ProviderItemsComp = () => {
  return (
    <Box width="100%" height="100%" direction="column" padding={3}>
      <Styles.Title>Itens pendentes</Styles.Title>

      <Box width="100%" marginTop={1}>
        <PendingItemsTab />
      </Box>
    </Box>
  )
}

export const ProviderItems = () => {
  return (
    <ProviderItemsProvider>
      <ProviderItemsComp />
    </ProviderItemsProvider>
  )
}
